// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-misused-promises */

import * as types from "./actionTypes";
import * as lookupApi from "../../apis/lookupApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

/*
 *  Action Creators
 *
 */
export function getStatesSuccess(states) {
	return { type: types.LU_GET_STATES_SUCCESS, states };
}

export function getCountriesSuccess() {
	return { type: types.LU_GET_COUNTRIES };
}

/*
 *  Thunks
 *
 */

export function getRegions(clientId, accessToken) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return lookupApi
				.getStates(clientId, accessToken)
				.then((res) => {
					dispatch(getStatesSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}

export function getCountries(clientId, accessToken) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(beginApiCall());

			return lookupApi
				.getCountries(clientId, accessToken)
				.then((res) => {
					dispatch(getCountriesSuccess());
					resolve(res);
				})
				.catch((error) => {
					dispatch(apiCallError(error));
					reject(error);
				});
		});
	};
}
